import { useQuery } from '@tanstack/react-query';
import { endpoints } from 'api/endpoints';
import { useRef } from 'react';
import { useAppStore } from 'stores/state';

export const useNameSuggestions = () => {
  const category = useAppStore((state) => state.category);

  const previousResults = useRef<string[]>([]);

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ['name-suggestions', category],
    queryFn: () => endpoints.suggestSiteNames({ category: category ?? '', previousResults: previousResults.current }),
    select: (response) => {
      previousResults.current = response.suggestions ?? [];
      return response.suggestions;
    },
  });

  return { suggestions: data, isLoading: isLoading || isFetching, refetch };
};
